import { http } from './http';

// vip 类型
export const getVipItems = () =>
    http({
        // baseUrl: baseUrl,
        url: '/api/payment/vip-items',
        method: 'get',
    })
// count 类型
export const getCreditsItems = () =>
    http({
        // baseUrl: baseUrl,
        url: '/api/payment/credits-items',
        method: 'get',
    })

// count buy
export const getCreditsBuy = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/payment/alipay/buy-credits',
        method: 'post',
        body: data,
        // query: params,
    })

// vip bug
export const getVipBuy = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/payment/alipay/buy-vip',
        method: 'post',
        body: data,
        // query: params,
    })

// 邀请历史
export const getInviteHistory = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/invite-history',
        method: 'get',
        query: params,
    })

// 算力充值 消耗
export const getCreditsDetails = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/credits/details',
        method: 'get',
        query: params,
    })
// 折扣码 /api/payment/discount-code
export const getDiscountCode = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/payment/discount-code',
        method: 'get',
        query: params,
    }) 

// 升级
export const getUpgradePrice = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/payment/vip-upgrade-price-info',
        method: 'get',
        query: params,
    })

// 订单状态
export const getOrderStatus = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/payment/alipay/order-status',
        method: 'get',
        query: params,
    })

    // 兑换码
export const postCode = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/redeem-code',
        method: 'post',
        body: data,
    })